import { useEffect, useState } from "react";
import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogCancel,
    AlertDialogAction,
} from "@/components/ui/alert-dialog";

let listener = null;

// Imperative, promise-based replacement for window.confirm() - resolves
// true if the user confirms, false if they cancel/dismiss. Renders through
// the single <ConfirmDialogHost/> mounted once at the app root (App.jsx),
// mirroring the merchant repo's identical helper.
export function confirmDialog({
    title = "Are you sure?",
    description,
    confirmText = "Confirm",
    cancelText = "Cancel",
    destructive = true,
} = {}) {
    return new Promise((resolve) => {
        if (!listener) {
            resolve(window.confirm(description || title));
            return;
        }
        listener({ title, description, confirmText, cancelText, destructive, resolve });
    });
}

export function ConfirmDialogHost() {
    const [state, setState] = useState(null);

    useEffect(() => {
        listener = (next) => setState(next);
        return () => { listener = null; };
    }, []);

    const close = (result) => {
        state?.resolve(result);
        setState(null);
    };

    return (
        <AlertDialog open={!!state} onOpenChange={(open) => { if (!open) close(false); }}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{state?.title}</AlertDialogTitle>
                    {state?.description && (
                        <AlertDialogDescription>{state.description}</AlertDialogDescription>
                    )}
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => close(false)}>{state?.cancelText}</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={() => close(true)}
                        className={state?.destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : undefined}
                    >
                        {state?.confirmText}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
